console.log("DEBUG: generative-art.js script has been loaded and parsed.");

export const sketch = (p) => {
    let particles = [];
    
    // A pre-defined, cool, futuristic color palette built around the red you liked.
    const colorPalette = ['#ff4757', '#e84118', '#353b48', '#273c75', '#f5f6fa'];

    // --- CONFIGURATION BASED ON RANDOM MODE ---
    let numParticles, connectDistance, particleSizeMin, particleSizeMax, particleSpeed;
    
    class Particle {
        constructor() {
            this.pos = p.createVector(p.random(p.width), p.random(p.height));
            this.vel = p.createVector(p.random(-particleSpeed, particleSpeed), p.random(-particleSpeed, particleSpeed));
            this.size = p.random(particleSizeMin, particleSizeMax);
            
            // --- NEW: Assign a random color and shape to each particle ---
            this.color = p.random(colorPalette);
            this.shape = p.random(['circle', 'square', 'triangle']);
        }
        
        update() { this.pos.add(this.vel); this.edges(); }
        
        draw() {
            p.noStroke();
            p.fill(this.color);
            
            // --- NEW: Draw a different shape based on the particle's property ---
            switch (this.shape) {
                case 'circle':
                    p.circle(this.pos.x, this.pos.y, this.size);
                    break;
                case 'square':
                    p.rectMode(p.CENTER); // Ensure square is drawn from its center
                    p.square(this.pos.x, this.pos.y, this.size);
                    break;
                case 'triangle':
                    const r = this.size / 2; // radius
                    p.triangle(
                        this.pos.x, this.pos.y - r,
                        this.pos.x - r, this.pos.y + r,
                        this.pos.x + r, this.pos.y + r
                    );
                    break;
            }
        }
        
        edges() { if (this.pos.x < 0 || this.pos.x > p.width) this.vel.x *= -1; if (this.pos.y < 0 || this.pos.y > p.height) this.vel.y *= -1; }
        
        checkConnect(otherParticles) {
            otherParticles.forEach(particle => {
                const d = p.dist(this.pos.x, this.pos.y, particle.pos.x, particle.pos.y);
                if (d < connectDistance) {
                    const lineAlpha = p.map(d, 0, connectDistance, 0.4, 0);
                    // Use a neutral, semi-transparent color for lines to avoid visual noise
                    p.stroke(`rgba(45, 52, 54, ${lineAlpha})`);
                    p.strokeWeight(1);
                    p.line(this.pos.x, this.pos.y, particle.pos.x, particle.pos.y);
                }
            });
        }
    }

    p.setup = () => {
        console.log("DEBUG: p5.js setup() function is RUNNING.");
        let canvas = p.createCanvas(p.windowWidth, p.windowHeight);
        console.log("DEBUG: Canvas created. Attaching to #canvas-container.");
        
        p.randomSeed(Date.now()); // Ensure true randomness

        // --- NEW: Randomly choose between "Overboard" and "Subtle" modes ---
        if (p.random() > 0.5) {
            console.log("MODE: Overboard");
            numParticles = window.innerWidth < 600 ? 100 : 200;
            connectDistance = 150;
            particleSizeMin = 4;
            particleSizeMax = 8;
            particleSpeed = 1;
        } else {
            console.log("MODE: Subtle");
            numParticles = window.innerWidth < 600 ? 40 : 80;
            connectDistance = 120;
            particleSizeMin = 2;
            particleSizeMax = 4;
            particleSpeed = 0.5;
        }

        canvas.parent('canvas-container');
        for (let i = 0; i < numParticles; i++) {
            particles.push(new Particle());
        }
    };

    p.draw = () => {
        p.clear();
        particles.forEach((particle, index) => {
            particle.update();
            particle.draw();
            particle.checkConnect(particles.slice(index));
        });
    };

    p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
    };
};